import { theme } from '@garnish/constants';

export const PICKER_OPTION_HEIGHT = 40;
export const PICKER_OPTIONS_WRAPPER_HEIGHT = PICKER_OPTION_HEIGHT * 5;
export const PICKER_OPTIONS_WRAPPER_TOP_OFFSET =
  PICKER_OPTIONS_WRAPPER_HEIGHT / 2 - PICKER_OPTION_HEIGHT / 2;
export const PICKER_OPTIONS_WRAPPER_TOP_OFFSET_SM = theme.spacing['6'];
export const PICKER_OPTIONS_WRAPPER_GAP_SM = theme.spacing['1'];
